import { Modal } from '@doordash/component-modal'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import Button from '@doordash/component-button'

import t from './strings'

export const noBankAccountModal = ({ onClose, isDasherDirectCopy }) => (
  <Modal
    onClose={onClose}
    title={isDasherDirectCopy ? t.dasherDirectTitle() : t.noBankModalTitle()}
    size={Modal.Sizes.Small}
    hasCloseButton={isDasherDirectCopy}
    actionsFillContainer={true}
    isFullScreenOnMobile={false}
    isDasherDirectCopy={isDasherDirectCopy}
  >
    <StackChildren>
      <Text>
        {isDasherDirectCopy
          ? t.noBankModalDasherDirectCopy1()
          : t.noBankModalCopy1()}
      </Text>
      <Text>
        {isDasherDirectCopy
          ? t.noBankModalDasherDirectCopy2()
          : t.noBankModalCopy2()}
      </Text>
      <Button onClick={() => onClose()}>
        {isDasherDirectCopy ? t.gotIt() : t.noBankModalPrimaryAction()}
      </Button>
    </StackChildren>
  </Modal>
)
